<div class="ss-layout">
  <app-supplysync-sidebar [isCollapsed]="isCollapsed"></app-supplysync-sidebar>

  <div class="ss-layout__main" [class.ss-layout__main--collapsed]="isCollapsed">
    <app-supplysync-navbar (toggleSidebar)="isCollapsed = $event"></app-supplysync-navbar>
    <div class="ss-layout__content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
